import { render, staticRenderFns } from "./VideoPoster.vue?vue&type=template&id=363aadb2&scoped=true&"
import script from "./VideoPoster.vue?vue&type=script&lang=js&"
export * from "./VideoPoster.vue?vue&type=script&lang=js&"
import style0 from "./VideoPoster.vue?vue&type=style&index=0&id=363aadb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363aadb2",
  null
  
)

export default component.exports